import { Pipe, PipeTransform } from '@angular/core';
import { NumeralService } from '../services/Numeral.service';

/**
 * Tax Estimates formatting helper.
 * Returns blank for null/undefined/'' so the UI does not show $0 for missing values.
 */
@Pipe({
  name: 'taxEstimatesAmount',
  standalone: true
})
export class TaxEstimatesAmountPipe implements PipeTransform {
  constructor(private numeralService: NumeralService) {}

  transform(value: any, format?: string): any {
    const fmt = format ? format : '$0,0';

    // keep blanks blank (no implicit $0)
    if (value === null || value === undefined || value === '') {
      return '';
    }

    return this.numeralService.format(fmt, value);
  }
}